/**
 * WorkshopTypeTile — small tree-species icon tile shared by the "New booking"
 * modal's picked-workshop card and the mobile workshop-picker list rows.
 * Mirrors `WorkshopSummaryCard`'s (unexported) local `WorkshopTypeIcon`.
 */
import { Sprout } from 'lucide-react';

import { getWorkshopTypeColors, getWorkshopTypeIcon } from '../../../utils/workshopTypeIcon';

export function WorkshopTypeTile({ name, size = 40 }: { name: string | null; size?: number }) {
  const icon = getWorkshopTypeIcon(name);
  const colors = getWorkshopTypeColors(name);
  return (
    <span
      className="flex-shrink-0 rounded-xl overflow-hidden flex items-center justify-center"
      style={{ width: size, height: size, backgroundColor: colors.bg, color: colors.text }}
    >
      {icon ? (
        <img src={icon} alt="" className="w-full h-full object-cover" />
      ) : (
        <Sprout size={Math.round(size * 0.45)} />
      )}
    </span>
  );
}
